import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { NgxsModule } from '@ngxs/store';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from './environment-injection';
import { ApiAuthService } from './services';
import { SnackbarService } from '@fitscovery/ui/snackbar';
import { AuthState } from './store';

@NgModule({
  imports: [
    CommonModule,
    AngularFireModule,
    AngularFireAuthModule,
    RouterModule,
    NgxsModule.forFeature([ AuthState ])
  ],
  providers: [
    SnackbarService
  ]
})
export class AuthDataAccessModule {

  public static forRoot(environment: Environment): ModuleWithProviders<AuthDataAccessModule> {
    return {
      ngModule: AuthDataAccessModule,
      providers: [
        ApiAuthService,
        { provide: APP_ENVIRONMENT, useValue: environment }
      ]
    };
  }
}
